import { ROOM_PRICE_NAMES, ROOM_SIZE_NAMES } from 'Globals/Constants'
import { useContext, useState } from 'react'
import styled from 'styled-components'
import './sliderVariables.scss'
import GlobalContext from 'Contexts/GlobalContext'
import { de } from 'Globals/Locale'
import HouseIcon from './Icons/HouseIcon'
import MoneyIcon from './Icons/MoneyIcon'
import { roomSizeNumberToStringConverter } from 'Utils'

const MapControls = ({
  price,
  setPrice,
  size,
  setSize,
}: {
  price: number
  setPrice: (price: number) => void
  size: number
  setSize: (size: number) => void
}) => {
  const { locale } = useContext(GlobalContext) ?? { locale: de }
  const currentRoomSize = roomSizeNumberToStringConverter(size)
  return (
    <ControlsWrapper>
      <ControlsTitle>{locale.controlsTitle}</ControlsTitle>
      <CategoriesWrapper>
        <Category>
          <Icon size={size}>
            <HouseIcon />
          </Icon>
          <SliderTitleWrapper>
            <Title
              dangerouslySetInnerHTML={{
                __html: locale.roomApartment.replace(
                  'FLATSIZE',
                  `<b>${currentRoomSize}</b>`
                ),
              }}
            ></Title>
            <Slider
              type='range'
              min='0'
              max='4'
              step='1'
              value={size}
              onChange={(e) => {
                setSize(+e.target.value)
              }}
            />
          </SliderTitleWrapper>
        </Category>
        <Category>
          <Icon size={price}>
            <MoneyIcon />
          </Icon>
          <SliderTitleWrapper>
            <Title>
              {locale.budgetUpTo} <b>{ROOM_PRICE_NAMES[price]} CHF</b>
            </Title>
            <Slider
              type='range'
              min='0'
              max='7'
              step='1'
              value={price}
              onChange={(e) => {
                setPrice(+e.target.value)
              }}
            />
          </SliderTitleWrapper>
        </Category>
      </CategoriesWrapper>
    </ControlsWrapper>
  )
}
const ControlsWrapper = styled.div``
const CategoriesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 1em 0;
  flex-direction: row;
  padding-right: 1em;
  padding-left: 0.5em;

  @media (max-width: 662px) {
    justify-content: center;
    flex-direction: column;
  }
`
const ControlsTitle = styled.h4`
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 1em;
  margin-top: 0.5em;
  padding-left: 0.5em;
  white-space: nowrap;
`
const SliderTitleWrapper = styled.div`
  width: 100%;
`
const Icon = styled.div<{ size: number }>`
  display: flex;
  align-items: center;
  svg {
    transform: scale(${(props) => '1.' + +props.size});
    transition: transform 500ms cubic-bezier(0.77, 0, 0.175, 1);
  }
`
const Slider = styled.input`
  /* width: 90%; */
`
const Category = styled.div`
  display: flex;
  width: 100%;
  /* flex-grow: 1; */
  /* min-width: 250px; */
  @media (max-width: 662px) {
    max-width: 500px;
    margin: 0.5em auto;
  }

  @media (min-width: 662px) {
    max-width: 310px;
    padding-right: 1em;
  }
`
const Title = styled.div``
const OnRange = styled.div.attrs<{
  percentage?: number
}>((props) => ({
  style: {
    left:
      typeof props.percentage !== 'undefined'
        ? 'calc((' +
          props.percentage / 100 +
          ' * ((100% - var(--half-thumb-size)) - var(--half-thumb-size))) + var(--half-thumb-size))'
        : 0,
  },
}))`
  position: absolute;
  top: 50%;
`
const CurrentValue = styled(OnRange)<{
  percentage?: number
  hasAnswered?: boolean
}>`
  font-size: 0.7em;
  &.hasAnswered {
    transition: transform 500ms cubic-bezier(0.77, 0, 0.175, 1);
    @media screen and (max-width: 600px) {
      transform: translateY(2.5em) translateX(-50%);
    }
    transform: translateY(2.3em) translateX(-50%);
  }
  transform: translateY(-2.5em) translateX(-50%);
  font-weight: 700;
`
export default MapControls
